<template>
  <div class="page-container">
    <div style="margin: 10px 0">
      <el-button type="primary" icon="el-icon-refresh" @click="load">重置</el-button>
      <div style="float: right; display: flex; gap: 10px; align-items: center">
        <el-select v-model="greenhouseId" clearable placeholder="选择棚/温室" style="width: 180px" @change="load">
          <el-option v-for="item in greenhouses" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <el-select v-if="isSuper" v-model="companyId" clearable placeholder="选择公司" style="width: 180px" @change="onCompanyChange">
          <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
    </div>

    <div class="table-wrapper">
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg">
        <el-table-column prop="companyName" label="公司" v-if="isSuper" />
        <el-table-column prop="greenhouseName" label="大棚/温室" />
        <el-table-column prop="temp1" label="棚内温度1(℃)" />
        <el-table-column prop="temp2" label="棚内温度2(℃)" />
        <el-table-column prop="temp3" label="棚内温度3(℃)" />
        <el-table-column prop="hum1" label="棚内湿度1(%)" />
        <el-table-column prop="hum2" label="棚内湿度2(%)" />
        <el-table-column prop="hum3" label="棚内湿度3(%)" />
        <el-table-column prop="light" label="光照(lux)" />
        <el-table-column prop="co21" label="CO₂1(ppm)" />
        <el-table-column prop="co22" label="CO₂2(ppm)" />
        <el-table-column prop="co23" label="CO₂3(ppm)" />
        <el-table-column prop="createdAt" label="时间" width="180" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-popconfirm title="确认删除该条数据？" @confirm="handleDelete(scope.row.id)">
              <el-button slot="reference" type="danger" size="mini">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SensorDataNew',
  data () {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return {
      user,
      isSuper: user.role === '超级管理员',
      companyId: user.companyid || null,
      greenhouseId: null,
      sid: null,
      companies: [],
      greenhouses: [],
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      headerBg: 'headerBg'
    }
  },
  mounted () {
    if (this.isSuper) {
      this.loadCompanies()
    } else {
      this.loadGreenhouses(this.companyId)
    }
    this.load()
  },
  methods: {
    load () {
      this.request.get('/api/sensors/page', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          companyId: this.companyId,
          greenhouseId: this.greenhouseId
        }
      }).then(res => {
        const data = res.data || res // 兼容直接返回 Page
        this.tableData = data.records || []
        this.total = data.total || 0
      })
    },
    loadCompanies () {
      this.request.get('/api/companies/').then(res => {
        if (res.code === '200') {
          this.companies = res.data || []
        }
      })
    },
    loadGreenhouses (companyId) {
      if (!companyId) {
        this.greenhouses = []
        this.greenhouseId = null
        return
      }
      this.request.get('/api/greenhouses/list', { params: { companyId } })
        .then(res => {
          if (res.code === '200') {
            this.greenhouses = res.data || []
          }
        })
    },
    onCompanyChange (val) {
      this.greenhouseId = null
      this.loadGreenhouses(val)
      this.load()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.load()
    },
    handleCurrentChange (page) {
      this.pageNum = page
      this.load()
    },
    handleDelete (id) {
      this.request.delete(`/sensors/${id}`).then(res => {
        if (res.code === '200') {
          this.$message.success('删除成功')
          this.load()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.headerBg {
  background: #f5f7fa;
}
.page-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 140px);
}
.table-wrapper {
  flex: 1;
  overflow: auto;
}
.pager {
  padding: 10px 0;
  background: #fff;
}
</style>

